import React from 'react';
import './TitleBarHeightSpacer.scss';
var TitleBarHeightSpacer = function (props) {
    return React.createElement("div", { className: "TitleBarHeightSpacer", style: { height: 'var(--TitleBarHeight)', marginTop: props.offset } });
};
export default TitleBarHeightSpacer;
